import { render, staticRenderFns } from "./takeNumberResult.vue?vue&type=template&id=46677e37&scoped=true"
import script from "./takeNumberResult.vue?vue&type=script&lang=js"
export * from "./takeNumberResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46677e37",
  null
  
)

export default component.exports